<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
         <div class="inpBox box">
        <el-form-item label="车牌号:">
          <el-input placeholder="" v-model="searchFrom.plateNumber" ></el-input>
        </el-form-item>
        <el-form-item label="司机姓名:">
          <el-input placeholder="" v-model="searchFrom.driverName" ></el-input>
        </el-form-item>
        <el-form-item label="司机手机号:">
          <el-input placeholder="" v-model="searchFrom.driverPhone" ></el-input>
        </el-form-item>
        <el-form-item label="开始维修日期:" class="item2" >
          <el-date-picker
              v-model="searchFrom.fillTimeStart"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
                 :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <br>
        <el-form-item label="维修单号:">
          <el-input placeholder="" v-model="searchFrom.rechargeOnlineNo" ></el-input>
        </el-form-item>
        <el-form-item label="小队:" class="">
          <el-select   v-model="searchFrom.teamCode" filterable placeholder="请选择" clearable   @change="xiaoduiChange">
            <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="状态:">
           <el-select  v-model="searchFrom.fillStatus" filterable placeholder="请选择">
             <el-option  label="全部" value="" ></el-option>
              <el-option  label="排队中" value="0" ></el-option>
              <el-option  label="维修中" value="1" ></el-option>
              <el-option  label="已完成" value="2" ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="完成维修日期:" class="item2" >
          <el-date-picker
              v-model="searchFrom.fillTimeEnd"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        </div>
        <!--  -->
       <div class="searchBtnBox">
            <el-button type="primary" size="mini" v-if="btnFlg[0]"  @click="getList(searchFrom)">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[1]" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
       <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change="selectGoods" @row-click="handleRowClick"
         style="width: 100%" height="100%"  center border>
       <!-- <el-table-column type="selection" width="55"></el-table-column> -->
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
       <el-table-column label="操作" width="160" >
          <template slot-scope="scope">
            <div>
              <el-button v-if="btnFlg[2]&&(scope.row.fillStatus=='1')" type="text" size="mini"  @click="wanchengFn(scope.row,1)">完成</el-button>
              <el-button v-if="btnFlg[3]" type="text" size="mini"  @click="editFn(scope.row)">修改</el-button>
              <el-button v-if="btnFlg[4]&&(scope.row.fillStatus=='2')" type="text" size="mini"  @click="delFn(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="rechargeOnlineNo" label="维修单号" align="center"
             min-width="230"></el-table-column>

        <el-table-column prop="fillStatus" width="80" :show-overflow-tooltip="true" label="状态">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.fillStatus == '0'" style="color:#F3BF1C">排队中</div>
              <div  v-if="scope.row.fillStatus == '1'" style="color:#F77706">维修中</div>
              <div  v-if="scope.row.fillStatus == '2'" style="color:#539B07">已完成</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车号" min-width="90" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" align="center"
             min-width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="fillTimeStart" label="开始维修日期" min-width="170" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="fillTimeEnd" label="结束维修日期" min-width="170" :formatter="dateTimeFormat"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="driverPhone" label="司机电话" align="center"
             min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="teamName" label="所属队" align="center"
          min-width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" min-width="80"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[20,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增修改 -->
    <el-dialog  title="修改"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="500px" center>
      <span>
        <el-form :inline="true" :rules="rules" :model="addForm" ref="addForm" class="demo-form-inline" label-width="130px" size="mini">
        <div class="">
           <el-form-item label="司机姓名:" prop="driverName" class="width1" >
            <el-input  placeholder=""  maxlength="50"  v-model="addForm.driverName" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="司机手机号:" prop="driverPhone" class="width1" >
            <el-input  placeholder=""  maxlength="50"  v-model="addForm.driverPhone" :readonly="true"></el-input>
          </el-form-item>
          <br>
          <el-form-item label="车牌号:" prop="vehicleId" class="width1"  >
            <el-select  v-model="addForm.vehicleId" filterable placeholder="请选择" @change="carChange" >
              <el-option v-for="item in carList" :label="item.vhcNo" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="维修开始时间" prop="fillTimeStart"  >
            <el-date-picker  @change="timeChange(2)"
              v-model="addForm.fillTimeStart"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item  label="维修结束时间" prop="fillTimeEnd" class="jiage" v-if="addForm.fillStatus=='2'">
            <el-date-picker  @change="timeChange(2)"
              v-model="addForm.fillTimeEnd"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addForm')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
// import { sShipDictionaryList, sShipDictionaryADD, sShipDictionaryUpdate, sShipDictionaryDelete } from '@/api/shipping'
import { pcRechargeOnlineList, driverDeleteRechargeOnline, driverUpdateRechargeOnline } from '@/api/newTMS'
import { organizationTree, cDlists, cVIlists } from '@/api/vgs-driver2.0'
import { formatterRowEmpty, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  components: {

  },
  data () {
    return {
      isWancheng: false,
      h: 500,
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      title: '新增',
      dialogVisible: false,
      XDList: [],
      XZList: [],
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      ids: [],
      loading: 'false',
      rules: {
        categoryName: [
          { required: true, message: '请输入品类名称', trigger: 'blur' }
        ]

      },
      addForm: {},
      isDisable: false,
      carList: [],
      btnFlg: [],
      btnIdArr: ['00IM0E0100', '00IM0E0200', '00IM0E0300', '00IM0E0400', '00IM0E0500']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    timeChange (n) {
      if (this.addForm.fillTimeEnd) {
        if (this.addForm.fillTimeStart > this.addForm.fillTimeEnd) {
          this.$alert('开始时间不能晚于结束时间', '系统提示')
          if (n == 1) {
            this.$set(this.addForm, 'fillTimeStart', null)
          } else {
            this.$set(this.addForm, 'fillTimeEnd', null)
          }
        }
      }
    },
    carChange (e) {
      if (e) {
        let json = this.carList.filter(item => item.id == e)
        this.$set(this.addForm, 'plateNumber', json[0].vhcNo)
      }
    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.tmsPlus + '/rechargeOnline/exportRechargeOnline',
        form,
        '维修列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.code == e)
        this.XZList = json[0].children
        this.$set(this.searchFrom, 'groupCode', null)
      }
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.businessType = 2
      pcRechargeOnlineList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.getList()
    },
    // 修改
    editFn (row, n) {
      if (n == 1) {
        this.isWancheng = true
      } else {
        this.isWancheng = false
        cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: row.teamId }).then(res => {
          this.loading = false
          this.carList = res
        })
      }
      this.addForm = JSON.parse(JSON.stringify(row))
      this.title = '修改'
      this.dialogVisible = true
    },
    wanchengFn (row) {
      this.$confirm('是否执行完成操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.fillTimeEnd = new Date().getTime()
        row.fillStatus = 2
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        driverUpdateRechargeOnline(row).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        driverDeleteRechargeOnline({
          ids: [row.id]
        }).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          driverUpdateRechargeOnline(this.addForm).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
            pcRechargeOnlineList().then(res => { this.plList = res })
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },

    closeDialog () {
      this.addForm = {}
      this.$refs.table.clearSelection()
      this.$refs.addForm.clearValidate()
      this.flag = false
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:340px!important;
}
/deep/.el-form{
  width: 100%;
}
.jiaoyan /deep/.el-input__inner{
      width: 180px;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
</style>
